import { GET_ORDERS, ORDERS_RECEIVED, ORDERS_AT_FACILITY_RECEIVED, ORDERS_ON_DOC_RECEIVED, ORDER_SAVED, SAVE_ORDER_DETAILS, GET_DELIVERED, DELIVERED_RECEIVED, ORDER_RECEIVED } from '../actions/OrderActions';

export const orders = (state = null, action) => {
  switch (action.type) {
    case GET_ORDERS:
      return Object.assign({}, state, { fetching: true });
    case ORDERS_RECEIVED:
      return Object.assign({}, state, { fetching: false, list: action.orders });
    case ORDERS_AT_FACILITY_RECEIVED:
      return Object.assign({}, state, { fetching: false, atFacility: action.orders });
    case ORDERS_ON_DOC_RECEIVED:
      return Object.assign({}, state, { fetching: false, onDoc: action.orders });
    case ORDER_SAVED:
      return Object.assign({}, state, { order: action.order });
    case SAVE_ORDER_DETAILS:
      return Object.assign({}, state, { from: action.from, to: action.to });
    case GET_DELIVERED:
      return Object.assign({}, state, { fetchingDelivered: true });
    case DELIVERED_RECEIVED:
      return Object.assign({}, state, { fetchingDelivered: false, delivered: action.orders });
    case ORDER_RECEIVED:
      return Object.assign({}, state, { order: action.order });
    default:
      return state;
  }
}

export default orders;


// WEBPACK FOOTER //
// ./src/reducers/orders.js